import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { LoadMoreStatic } from '../LoadMoreStatic/LoadMoreStatic';

@Component
export class StoryFilters extends ThemeComponent {

    @Ref() filterButton !: HTMLButtonElement[];

    private loadMoreStatic !: LoadMoreStatic|null;
    private featuredStory !: HTMLDivElement|null;

    constructor() {
        super();
        this.loadMoreStatic = document.querySelector('load-more-static');
        this.featuredStory = document.querySelector('.featured-story');
    }

    init() {
        this.$listen(this, 'click', (event: Event) => {


            const targetButton = event.target as HTMLButtonElement;
            if (this.filterButton.includes(targetButton)) {

                const targetFilter = targetButton.getAttribute('data-filter-handle');

                if (this.featuredStory) {
                    // If the button is the 'All' filter, show the
                    // featured story
                    if (targetFilter != 'all') {
                        this.featuredStory.classList.add('hidden');
                    } else {
                        // Hide the featured story
                        this.featuredStory.classList.remove('hidden');
                    }
                }

                if (this.loadMoreStatic && targetFilter) {
                    this.loadMoreStatic.setFilter(targetFilter);
                    this.selectFilter(targetButton);
                }

            }
        });
    }

    selectFilter(targetButton: HTMLButtonElement) {
        for (const button of this.filterButton) {
            button.classList.remove('link--active');
        }

        targetButton.classList.add('link--active');
    }
}
